import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../../base-service/base-api.service';

@Injectable()
export class SearchCriteriaService extends BaseApiService {

    /**
     * Runs the omnisearch for the given context
     * @return: List of items that match the search string.
     */
    search = (searchString: string, context: number): Observable<any> => this.get('Foundation/SearchCoordinator/SearchType/' + context + '/Value/' + searchString);
}
